import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  CustomInput,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { gAPI_Property_List, gAPI_Group_By_Id } from '../../../../../../constants/APIs';
import roleListData from '../../../../../../data/rolelist.json';

export default function InviteUsersForm({
  formLabel,
  visible,
  toggle,
  id,
  submit
}) {
  const [propertyList, setPropertyList] = useState([]);
  const [roleList, setRolesList] = useState([]);
  const [usersData, setUsersData] = useState({
    groupId: getGroupID(),
    groupName: '',
    email: '',
    properties: ['-1'],
    roles: ['Admin'],
    creator: 'dashboard',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    isBMB:false,
    isaiva:true,
  });

  useEffect(() => {

    setRolesList(roleListData.data.map(p => ({
      id: p.id,
      name: p.name,
      checked: false,
    })));

    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
    })
      .then(res => {

        setPropertyList(res.data.map(p => ({
          id: p.id,
          name: p.name,
          checked: false,
        })));



        // var all = {
        //   id: '-1',
        //   name: 'All',
        //   checked: false,
        // };


        // setPropertyList(all, ...propertyList);

      })
      .catch(err => console.error(err));

    AxiosAPI({
      method: 'get',
      url: `${gAPI_Group_By_Id}/${getGroupID()}`,
    })
      .then(res => {

        setUsersData({
          ...usersData,
          groupId: getGroupID(),
          groupName: res.data.name
        });
      })
      .catch(err => console.error(err));

  }, []);

  const handleChange = e => {
    setUsersData({
      ...usersData,
      [e.target.name]: e.target.value,
    });
  };

  const handlePropertiesChange = e => {
    const values = propertyList.map(elem => {
      if (elem.id === e.target.value) {
        if (elem.checked) {
          elem.checked = false;
        } else if (!elem.checked) {
          elem.checked = true;
        }
      }
      return {
        ...elem,
      };
    });
    setPropertyList(values);
  };

  const handleRoleChange = e => {
    const values = roleList.map(elem => {
      if (elem.name === e.target.value) {
        if (elem.checked) {
          elem.checked = false;
        } else if (!elem.checked) {
          elem.checked = true;
        }
      }
      return {
        ...elem,
      };
    });
    setRolesList(values);
  };


  useEffect(() => {

    const appPropertiesArr = propertyList
      .filter(elem => elem.checked === true)
      .map(elem => elem.id);


    const appRolesArr = roleList
      .filter(elem => elem.checked === true)
      .map(elem => elem.id);

    setUsersData({
      ...usersData,
      properties: appPropertiesArr,
      roles: appRolesArr
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyList, roleList]);

  const handleSubmit = () => {
    submit(usersData);
  };

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <Row>
                <Colxx sm={4} className="mb-3">
                  <Label>First Name</Label>
                  <Input
                    type="text"
                    onChange={handleChange}
                    name="firstName"
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Last Name</Label>
                  <Input
                    type="text"
                    onChange={handleChange}
                    name="lastName"
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Email</Label>
                  <Input
                    type="text"
                    onChange={handleChange}
                    name="email"
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Phone Number</Label>
                  <Input
                    type="text"
                    onChange={handleChange}
                    name="phoneNumber"
                  />
                </Colxx>
              </Row>
              <h4>Roles & Businesses</h4>
              <Row>
                <Colxx sm={4}>
                  <FormGroup>
                    <Label>Roles</Label>

                    {roleList.map((elem, index) => {
                      if (elem.name !== 'Agent') {                      
                        return (<Fragment>

                          <CustomInput
                            key={index}
                            type="checkbox"
                            value={elem.name}
                            id={elem.id}
                            onChange={handleRoleChange}
                            defaultChecked={elem.checked}
                          >
                            {elem.name === 'Admin'&&'Business Account (Admin)'}
                            {elem.name === 'User'&& 'Staff Account'}
                            {elem.name === 'View' && 'Vouchers Account'}
                          </CustomInput>

                        </Fragment>);
                      }
                    }
                    )}

                  </FormGroup>
                </Colxx>
                <Colxx sm={4}>
                  <FormGroup>
                    <Label>Businesses</Label>
                    {propertyList.map((elem, index) => (
                      <CustomInput
                        key={index}
                        type="checkbox"
                        value={elem.id}
                        id={elem.id}
                        onChange={handlePropertiesChange}
                        checked={elem.checked}
                      >
                        {elem.name}
                      </CustomInput>
                    ))}
                  </FormGroup>
                </Colxx>
              </Row>
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Save
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

InviteUsersForm.propTypes = {
  // formLabel: PropTypes.string.isRequired,
  // visible: PropTypes.bool.isRequired,
  // toggle: PropTypes.func.isRequired,
  // updateRatePlansData: PropTypes.shape({
  //   name: PropTypes.array.isRequired,
  //   description: PropTypes.array.isRequired,
  //   conditions: PropTypes.array.isRequired,
  //   status: PropTypes.string.isRequired,
  // }),
  // applicableAddOnsWithIdAndName: PropTypes.array.isRequired,
  // includedAddOnsWithIdAndName: PropTypes.array.isRequired,
  // applicablePromosWithIdAndName: PropTypes.array.isRequired,
};
